import { h } from 'vue';

import param from '~/utils/url/param'
export default {
  name: 'BtnWhatsapp',
  props: {
    title: {
      type: String,
      default: 'Quero agendar uma consulta pelo whatsapp.'
    }
  },
  computed: {
    isComercial() {
      const d = new Date().getDay(),
        h = new Date().getHours()
      return d !== 0 && d !== 6 && ((h >= 8 && h <= 12) || (h >= 14 && h <= 18))
    }
  },
  methods: {
    async open() {
      window.open(
        'https://api.whatsapp.com/send' +
          param({
            phone: '55' + site.whatsapp.replace(/[^0-9]+/g, ''),
            text: this.title
          }),
        '__blank'
      )
    }
  }
}
